// Display-only: find genuine matches between a person's stated favourites and a product.
const STOP = new Set(["and", "the", "with", "for", "her", "his", "their", "flavour", "flavor", "colour", "color", "flowers", "flower", "any", "all", "very", "loves", "love", "likes", "like"]);

const words = (s) => String(s || "").toLowerCase().match(/[a-z]+/g) || [];
const phrases = (s) => String(s || "").split(/,|\/|&|\band\b|\bor\b/i).map((p) => p.trim()).filter(Boolean);
const sig = (p) => words(p).filter((w) => w.length > 2 && !STOP.has(w));
const cap = (s) => s.charAt(0).toUpperCase() + s.slice(1);

const productWords = (p) => {
  const parts = [p.name, ...(p.tags || []), ...(p.flavors || []),
    ...(p.variants || []).map((v) => v.option_label), ...(p.weight_variants || []).map((v) => v.weight_label)];
  return new Set(parts.flatMap(words));
};

const has = (set, w) => set.has(w) || set.has(`${w}s`) || set.has(`${w}es`) || (w.endsWith("s") && set.has(w.slice(0, -1)));

const firstMatch = (pref, set) => phrases(pref).find((ph) => {
  const ws = sig(ph);
  return ws.length > 0 && ws.every((w) => has(set, w));
});

export const pronounOf = (rel) => {
  const g = String(rel?.gender || "").toLowerCase();
  if (["female", "woman", "f"].includes(g)) return "her";
  if (["male", "man", "m"].includes(g)) return "his";
  return "their";
};

export function personalTagFor(product, rel) {
  if (!product || !rel) return null;
  const set = productWords(product);
  const their = pronounOf(rel);
  const be = (s) => (/[^s]s$/i.test(s.trim()) ? "are" : "is");
  const food = firstMatch(rel.fav_food, set);
  if (food) return { tag: "Must-have", reason: `${cap(food)} ${be(food)} one of ${their} stated favourites.` };
  const flower = firstMatch(rel.fav_flower, set);
  if (flower) return { tag: "Must-have", reason: `${cap(flower)} ${be(flower)} ${their} favourite flower${be(flower) === "are" ? "s" : ""}.` };
  const color = firstMatch(rel.fav_color, set);
  if (color) return { tag: "Matches Their Taste", reason: `You mentioned ${color.toLowerCase()} is ${their} favourite colour.` };
  return null;
}

// Map element_index -> {tag, reason}; a non-generic tag shared by every card is dropped.
export function personalTags(rows, rel) {
  const out = {};
  rows.forEach((r) => { if (!r.user_changed) { const t = personalTagFor(r.product, rel); if (t) out[r.element_index] = t; } });
  if (rows.length > 1) {
    ["Must-have", "Matches Their Taste"].forEach((tag) => {
      if (rows.every((r) => out[r.element_index]?.tag === tag)) rows.forEach((r) => delete out[r.element_index]);
    });
  }
  return out;
}
